import {
  DbotEvent,
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { ConversionOfShares, ConversionOfSharesForm } from "./conversionOfSharesDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<ConversionOfShares>,
  data?: ConversionOfShares,
): ConversionOfSharesForm {
  return new ConversionOfSharesForm(dispatch, context, data);
}

export function applyForm(form: ConversionOfSharesForm): ConversionOfShares {
  const toShareTypeId = form.toShareTypeModel.value?.sharetypeId;
  return {
    type: DecisionType.conversionOfShares,
    fromShareTypeId: form.fromShareTypeModel.value?.sharetypeId,
    toShareTypeId: toShareTypeId,
    toNewShareTypeCode:
      toShareTypeId === 0 ? form.toShareTypeModel.value?.shareTypeCode : undefined,
    articleOfAssociationNumber: form.articleOfAssociationNumber.selected,
    convertAllShares: form.convertAllShares.value ?? true,
    updateArticlesAutomatically: form.updateArticlesAutomatically.value,
    articleChanges: form.articleChangeModel.articleChanges,
    sharesPerShareholder: form.sharesPerShareholder.flatMap((s) =>
      s.numberOfShares.parsedValue
        ? {
            shareholderId: s.shareholder.id,
            shareholderName: s.shareholder.name,
            numberOfShares: s.numberOfShares.parsedValue,
          }
        : [],
    ),
  };
}

export function validate(form: ConversionOfSharesForm) {
  return form.validate();
}

export function isValid(form: ConversionOfSharesForm) {
  return form.isValid;
}

export function handleEvent(form: ConversionOfSharesForm, event: DbotEvent) {
  return form.handleEvent(event);
}

export const conversionOfSharesHandler: DecisionTypeHandler<
  DecisionType.conversionOfShares,
  ConversionOfShares,
  ConversionOfSharesForm
> = {
  type: DecisionType.conversionOfShares,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent,
};
